import { Copy, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { LineItems } from 'src/common/Order/OrderReceipt/LineItems';
import { IItem } from 'src/types/OrderHistory';

export interface IGroupOrderLineProps {
  dinerName: string;
  isHost: boolean;
  items: IItem[];
  showBorderBottom?: boolean;
}
export function GroupOrderLine({
  dinerName,
  isHost,
  items,
  showBorderBottom,
}: IGroupOrderLineProps): JSX.Element {
  const isHostWithoutItems = isHost && items?.length === 0;

  return (
    <Stack
      y="md"
      borderBottomWidth={showBorderBottom ? '1px' : '0'}
      borderBottomStyle="solid"
      borderBottomColor="lightLine"
    >
      <Stack y="x-sm">
        <Stack y={isHostWithoutItems ? 'md' : 'none'}>
          <Heading variant="h5">
            {dinerName}'s items{isHost && ' (host)'}
          </Heading>
        </Stack>

        {isHostWithoutItems && (
          <Stack y="x-sm">
            <Copy variant="lead" color="secondaryText">
              You haven't added any items
            </Copy>
          </Stack>
        )}
      </Stack>
      <LineItems items={items} />
    </Stack>
  );
}
